module.exports = __webpack_public_path__ + "img/arbor_b1.803c9b99.jpg";